import styled from 'styled-components';
export const SearchContainer = styled.div`
  padding: 8px;
  position: sticky;
  top: 0;
  background: var(--input-background);
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
